export const AVAILABLE_CODE_MODES = {
  js: {
    label: 'JavaScript',
    mode: 'application/javascript',
  },
  json: {
    label: 'JSON',
    mode: 'application/json',
  },
  html: {
    label: 'HTML / XML',
    mode: {
      name: 'xml',
      htmlMode: true,
    },
  },
  markdown: {
    label: 'Markdown',
    mode: 'markdown',
  },
  css: {
    label: 'CSS',
    mode: 'text/css',
  },
  scss: {
    label: 'Scss',
    mode: 'text/x-scss',
  },
  php: {
    label: 'PHP',
    mode: 'php',
  },
  python: {
    label: 'Python',
    mode: 'python',
  },
  ruby: {
    label: 'Ruby',
    mode: 'ruby',
  },
  bash: {
    label: 'Bash',
    mode: 'shell',
  },
  cs: {
    label: 'C#',
    mode: 'text/x-csharp',
  },
  'c++': {
    label: 'C++',
    mode: 'text/x-c++src',
  },
  java: {
    label: 'Java',
    mode: 'text/x-java',
  },
  oc: {
    label: 'Objective C',
    mode: 'text/x-objectivec',
  },
  swift: {
    label: 'Swift',
    mode: 'swift',
  },
  less: {
    label: 'Less',
    mode: 'text/x-less',
  },
  diff: {
    label: 'Diff',
    mode: 'diff',
  },
  coffeescript: {
    label: 'CoffeeScript',
    mode: 'coffeescript',
  },
  sql: {
    label: 'SQL',
    mode: 'sql',
  },
  erlang: {
    label: 'Erlang',
    mode: 'erlang',
  },
  parl: {
    label: 'Perl',
    mode: 'perl',
  },
  lisp: {
    label: 'Lisp',
    mode: 'commonlisp',
  },
};
